import { render, staticRenderFns } from "./object-renderer.vue?vue&type=template&id=af1e484a&"
import script from "./object-renderer.vue?vue&type=script&lang=js&"
export * from "./object-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports